{
  "selectAsField": "Sélectionner \"{value}\" comme {fieldName}",
  "typeToSearchField": "Tapez pour rechercher un {fieldName}",
  "licenseFieldLabel": "Sélectionner la plaque d'immatriculation (ex. 215BG2)",
  "licenseFieldName": "Plaque d'immatriculation",
  "licensePlaceholder": "Rechercher par plaque d'immatriculation",
  "dotFieldLabel": "Sélectionner le numéro DOT",
  "dotFieldName": "Numéro DOT",
  "dotPlaceholder": "Rechercher par numéro DOT",
  "chooseOneOption": "Choisissez l'une des options ci-dessous"
}
